<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Transition name="fade">
    <div class="col-sm-12 nopads list-container">
      <div
        v-if="results.length > 0"
        class="col-sm-12 list-content result-table"
      >
          <vue3-datatable
              :rows="results"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="65vh"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
              @row-click="emitDetails"
          >
              <template #created="row">
                  {{ toLocalTime(row.value.created) }}
              </template>
              <template #type="row">
                  {{ getInspectionTypeName(row.value.type) }}
              </template>
              <template #frequency="row">
                  {{ getInspectionFrequency(row.value.frequency) }}
              </template>
              <template #outcome="data">
                  <font-awesome-icon
                      v-if="hasStatus(data.value.results, resultBan)"
                      icon="exclamation-circle"
                      class="ban"
                  />
                  <font-awesome-icon
                      v-else-if="hasStatus(data.value.results, resultDefect)"
                      icon="exclamation-circle"
                      class="defect"
                  />
              </template>
              <template #target="row">
                  {{ getInspectionTarget(row.value) }}
              </template>
              <template #inspector="row">
                  {{ getInspector(row.value.reporter) }}
              </template>
              <template #contract="row">
                  {{ row.value.contract ? row.value.contract.name : '' }}
              </template>
          </vue3-datatable>
      </div>
    </div>
  </Transition>
</template>

<script>
import {inspectionHelper} from '../../mixins/InspectionMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'VehicleInspectionList',
    components: {Vue3Datatable},
    mixins: [inspectionHelper, timeUtils],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            fields: [
                { field: 'outcome', title: '', sort: false},
                { field: 'created', title: this.$t('ins_report.list_label.created'), sort: true, headerClass: 'routa-table-header'},
                { field: 'type', title: this.$t('ins_report.list_label.report_type'), sort: true, headerClass: 'routa-table-header'},
                { field: 'name', title: this.$t('ins_report.list_label.name'), sort: true, headerClass: 'routa-table-header'},
                { field: 'frequency', title: this.$t('inspection_editor.inspection_frequency'), sort: true, headerClass: 'routa-table-header'},
                { field: 'target', title: this.$t('ins_report.list_label.target'), sort: true, headerClass: 'routa-table-header'},
                { field: 'inspector', title: this.$t('ins_report.list_label.inspector'), sort: true, headerClass: 'routa-table-header'},
                { field: 'contract', title: this.$t('ins_report.list_label.contract'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    methods: {
        emitDetails: function (details) {
            this.$emit('details', details)
        },
        hasStatus: function (results, status) {
            return results.find(item => item.result === status) !== undefined
        },
        sortCompare(aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
            if (key === 'inspector') {
                const a = this.getInspector(aRow['reporter'])
                const b = this.getInspector(bRow['reporter'])
                return a.localeCompare(b, compareLocale, compareOptions)
            } else if (key === 'target') {
                const a = this.getInspectionTarget(aRow)
                const b = this.getInspectionTarget(bRow)
                return a.localeCompare(b, compareLocale, compareOptions)
            } else if (key === 'created') {
                const a = aRow.created
                const b = bRow.created
                return a < b ? -1 : a > b ? 1 : 0
            } else if (key === 'frequency') {
                const a = this.getInspectionFrequency(aRow.frequency)
                const b = this.getInspectionFrequency(bRow.frequency)
                return a < b ? -1 : a > b ? 1 : 0
            }
            return false
        }
    }
}
</script>
